import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  MenuItem,
  Avatar,
  Grid,
  Drawer,
} from "@mui/material";

import {
  apiCallDeleteMedia,
  apiClaimMediaListVenue,
  apiCallClaimMediaApprove,
} from "../../../../Core/Apicall";

import DeleteIcon from "@mui/icons-material/Delete";
import EmptyData from "../../../Common/EmptyData/EmptyData";
import CommonPagination from "../../../Common/CommonPagination/CommonPagination";
import CommonShimmer from "../../../Common/CommonShimmer/CommonShimmer";
import { useSelector } from "react-redux";
import { RootState } from "../../../../Redux/Store";
import VideocamIcon from "@mui/icons-material/Videocam";
import { useNavigate } from "react-router-dom";
import MediaLeftMenu from "./MediaLeftMenu/MediaLeftMenu";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";

interface Report {
  _id: string;
  mediaUrl: string;
  fullName: string;
  approvalStatus?: string;
  mediaType: string;
}

const ReportClaimedMedia: React.FC<{ venueId: string }> = ({ venueId }) => {
  const [reports, setReports] = useState<Report[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [openDelete, setOpenDelete] = useState<string | null>(null);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [status, setStatus] = useState("UnderApproval");

  const [selectedMediaForPreview, setSelectedMediaForPreview] =
    useState<null | { type: string; url: string }>(null);
  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const userdata: any = useSelector((state: RootState) => state.global.token);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedMediaId, setSelectedMediaId] = useState<string | null>(null);

  const fetchReports = async () => {
    setLoading(true);
    try {
      const data = { venueId, offset: page, limit: rowsPerPage };
      const res = await apiClaimMediaListVenue(data);
      if (res.success) {
        setReports(res.data || []);
        setTotalItems(res.totalCount || 0);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, [page, rowsPerPage, status]);

  const handleStatusChange = async (id: string, value: string) => {
    try {
      await apiCallClaimMediaApprove({
        userId: userdata?.data?.userId,
        venueMediaId: id,
        approvalStatus: value,
      });

      if (value === "Verified") {
        setReports((prev) => prev.filter((r) => r._id !== id));
        setTotalItems((prev) => prev - 1);
      } else {
        setReports((prev) =>
          prev.map((r) => (r._id === id ? { ...r, approvalStatus: value } : r))
        );
      }
    } catch (error) {}
  };

  const handleDelete = async (id: string) => {
    try {
      const data = {
        adminId: userdata?.data?.userId,
        venueMediaId: id,
        isDelete: true,
      };
      await apiCallDeleteMedia(data);
      setOpenDelete(null);
      fetchReports();
    } catch (error) {}
  };

  return (
    <Box p={3}>
      <Paper
        className="bg-white mt-3 border-20"
        sx={{ borderRadius: 3, overflow: "hidden" }}
      >
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Media</TableCell>

                <TableCell>Reports</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Delete</TableCell>
                <TableCell>Media User</TableCell>
              </TableRow>
            </TableHead>
            {loading === false && (
              <TableBody>
                {reports.map((r: any) => (
                  <TableRow key={r._id}>
                    <TableCell>
                      {r.mediaType === "Image" && (
                        <img
                          src={r.mediaUrl}
                          alt="Media"
                          style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "60px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          onClick={() => setPreviewImage(r.mediaUrl)}
                        />
                      )}
                      {r.mediaType === "Video" && (
                        <Avatar
                          variant="rounded"
                          onClick={() =>
                            setSelectedMediaForPreview({
                              type: "Video",
                              url: r.mediaUrl,
                            })
                          }
                          sx={{
                            width: "60px",
                            height: "60px",
                            bgcolor: "secondary.main",
                            cursor: "pointer",
                          }}
                        >
                          <VideocamIcon sx={{ color: "#fff" }} />
                        </Avatar>
                      )}
                    </TableCell>

                    <TableCell
                      onClick={() => {
                        setSelectedMediaId(r.mediaId);
                        setDrawerOpen(true);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {r.totalReports ? r.totalReports : "-"}
                    </TableCell>

                    <TableCell>
                      <TextField
                        select
                        value={r.approvalStatus || ""}
                        onChange={(e) =>
                          handleStatusChange(r._id, e.target.value)
                        }
                        style={{ width: "160px", fontSize: "14px" }}
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "20px",
                            fontSize: "14px",
                            "& fieldset": {
                              borderColor:
                                r.approvalStatus === "Verified"
                                  ? "green"
                                  : r.approvalStatus === "Rejected"
                                  ? "red"
                                  : "orange",
                              fontSize: "14px",
                            },
                            "&:hover fieldset": {
                              borderColor:
                                r.approvalStatus === "Verified"
                                  ? "green"
                                  : r.approvalStatus === "Rejected"
                                  ? "red"
                                  : "orange",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor:
                                r.approvalStatus === "Verified"
                                  ? "green"
                                  : r.approvalStatus === "Rejected"
                                  ? "red"
                                  : "orange", // override blue focus border
                            },
                          },
                          "& .MuiSelect-select": {
                            color:
                              r.approvalStatus === "Verified"
                                ? "green"
                                : r.approvalStatus === "Rejected"
                                ? "red"
                                : "orange",
                            fontWeight: 600,
                          },
                        }}
                      >
                        <MenuItem value="Verified">Verified</MenuItem>
                        <MenuItem value="UnderApproval">
                          Under Approval
                        </MenuItem>
                        <MenuItem value="Rejected">Rejected</MenuItem>
                      </TextField>
                    </TableCell>

                    <TableCell>
                      <IconButton onClick={() => setOpenDelete(r._id)}>
                        <DeleteIcon style={{ color: "red" }} />
                      </IconButton>

                      <Dialog
                        open={openDelete === r._id}
                        onClose={() => setOpenDelete(null)}
                      >
                        <DialogTitle>Delete Media</DialogTitle>
                        <DialogContent>
                          Are you sure you want to delete this media?
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={() => setOpenDelete(null)}>
                            Cancel
                          </Button>
                          <Button
                            color="error"
                            variant="contained"
                            onClick={() => handleDelete(r._id)}
                          >
                            Delete
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </TableCell>

                    <TableCell style={{ cursor: "pointer" }}>
                      <IconButton
                        onClick={() => {
                          setSelectedMediaId(r.mediaId);
                          setDrawerOpen(true);
                        }}
                        color="primary"
                      >
                        <VisibilityIcon sx={{ color: "black" }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>

          {loading && (
            <div style={{ padding: "10px" }}>
              <CommonShimmer />
            </div>
          )}
        </TableContainer>

        <EmptyData data={reports} />

        <CommonPagination
          page={page}
          rowsPerPage={rowsPerPage}
          totalItems={totalItems}
          totalPages={totalPages}
          onPageChange={setPage}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(e);
            setPage(1);
          }}
        />
      </Paper>
      <Dialog
        open={!!previewImage || !!selectedMediaForPreview}
        onClose={() => {
          setPreviewImage(null);
          setSelectedMediaForPreview(null);
        }}
        maxWidth="md"
      >
        <DialogContent sx={{ p: 0 }}>
          {previewImage && (
            <img
              src={previewImage}
              alt="Preview"
              style={{
                width: "500px",
                height: "300px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          )}

          {selectedMediaForPreview?.type === "Video" && (
            <video
              src={selectedMediaForPreview.url}
              controls
              autoPlay
              style={{
                width: "500px",
                height: "auto",
                borderRadius: "8px",
              }}
            />
          )}
        </DialogContent>
      </Dialog>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: "70%", padding: 2 } }}
      >
        {/* Close Button */}
        <Box sx={{ position: "absolute", top: 6, left: 6 }}>
          <IconButton onClick={() => setDrawerOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent>
          {selectedMediaId && <MediaLeftMenu mediaId={selectedMediaId} />}
        </DialogContent>
      </Drawer>
    </Box>
  );
};

export default ReportClaimedMedia;
